let acc = document.getElementsByClassName('toggle-chevron');
let i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener('click', function() {
    this.classList.toggle('toggle-active');

    let panel = this.nextElementSibling;
    if (panel !== null) {
      panel.classList.toggle('view-active');
    }

    this.previousElementSibling.classList.toggle('title-active');
  });
}
